export default {
	meta: {
		title: 'Fondinnov',
		titleTemplate: '%s | Fondinnov',
		description: 'Plateforme Innovation.'
	},
	defaultErrorMessage: 'Une erreur inconnue est survenue',
	security: {
		expired: 'Votre session a expiré.'
	}
};
